'use strict';

export default class FixedContent {
    constructor(selector){
        this.selector = selector;
        if(!this.selector) return false
        this.init(); 
    }

    init(){
        $(window).scroll(()=>{
            var bottom = 12,
            scrollVal = $(window).scrollTop(),
            windowHeight = $(window).height(),
            footerOffset = 0;
            if($('footer').length)
                footerOffset = $('footer').offset().top + 5;
        
            if(scrollVal + windowHeight > footerOffset){
                $(this.selector).css('bottom', bottom  + scrollVal + windowHeight - footerOffset + 5);
            }
            else if(parseInt($(this.selector).css('bottom')) > bottom){
                $(this.selector).css('bottom', bottom);
            }
        })
    }
}